import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'octet',
  standalone: true,
})
export class OctetPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value == null) {
      return '';
    } else {
      return this.formatBytes(+value);
    }
  }

  formatBytes(bytes, decimals = 2): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['octets', 'Ko', 'Mo'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
